import { render, staticRenderFns } from "./color-picture.vue?vue&type=template&id=09d53c11"
import script from "./color-picture.vue?vue&type=script&lang=js"
export * from "./color-picture.vue?vue&type=script&lang=js"
import style0 from "./color-picture.vue?vue&type=style&index=0&id=09d53c11&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports